import MapServiceModel from '@/models/MapServiceModel';
import doc             from '@widesk-core/decorators/doc';

/** Cible de `ProjectModel.regenerateSlug` : `PATCH /projects/{id}/regenerate_slug`. */
@doc.path('/projects/{id}/regenerate_slug')
export default class ProjectRegenerateSlugModel extends MapServiceModel {}
